import { withStyles, Box, SupportedCurrencies } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button, MaterialSymbol, UtilButton } from 'UI';
import styles from './DefaultFundingMethods.module.scss';

const cn = withStyles(styles);

type MaterialSymbolIcon = React.ComponentProps<typeof MaterialSymbol>['icon'];

export type FundingMethodRowProps = {
  icon: MaterialSymbolIcon;
  iconFill?: number;
  accountNumber: string;
  currency?: SupportedCurrencies;
  onClickAccountDetails: () => void;
  fee: string;
  isFeeFree: boolean;
  settlementSpeed: string;
  connectionType?: string;
  onClickFund?: () => void;
  onClickWithdraw?: () => void;
};

export default function FundingMethodRow({
  icon,
  iconFill,
  accountNumber,
  currency,
  onClickAccountDetails,
  fee,
  isFeeFree,
  settlementSpeed,
  connectionType,
  onClickFund,
  onClickWithdraw,
}: FundingMethodRowProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.OperationalAccounts' });

  return (
    <div className={cn('row')} data-testid={`funding-method-row-${accountNumber}`}>
      <Box ai="center" gapSize="16px" grow="1">
        <div className={cn('thumbnail')}>
          <MaterialSymbol icon={icon} fillAmount={iconFill} size="24px" />
        </div>

        <Box flx="col" gapSize="4px">
          <UtilButton size="medium" className={cn('accountLink')} onClick={onClickAccountDetails}>
            {currency ? `${accountNumber} | ${currency}` : accountNumber}
          </UtilButton>

          <div className={cn('metatext')}>
            <span className={cn(isFeeFree && 'feeFree')}>{fee}</span>
            <span>{` · ${settlementSpeed}${connectionType ? ` · ${connectionType}` : ''}`}</span>
          </div>
        </Box>
      </Box>

      <Box gapSize="8px" ai="center">
        {onClickFund && (
          <Button id={`funding-method-fund-${accountNumber}`} size="small" onClick={onClickFund}>
            {t('Card.addFunds', { defaultValue: 'Add Funds' })}
          </Button>
        )}

        {onClickWithdraw && (
          <Button id={`funding-method-withdraw-${accountNumber}`} size="small" onClick={onClickWithdraw}>
            {t('Card.withdraw', { defaultValue: 'Withdraw' })}
          </Button>
        )}
      </Box>
    </div>
  );
}
